/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import PaginatedListState from 'flarum/common/states/PaginatedListState';

export default class AchievementUsersListState extends PaginatedListState {
	constructor(levelId) {
		super({}, 1, 30);

		this.levelId = levelId;
	}

	get type() {
		return 'achievement_level_users/' + this.levelId;
	}
}
